var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list"},[_c('div',[_vm._v("微信页面")]),_c('a',{attrs:{"href":"http://www.beian.miit.gov.cn/","target":"_blank","rel":"nofollow"}},[_vm._v(_vm._s(_vm.$t("home.icp")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }